$(document).ready(function(){
  $(window).scroll(function() {
    if ($(window).scrollTop() > 30) {
      $("#barE31").fadeIn(200);
    } else {
      $("#barE31").fadeOut(200);
    }
  });

  $('.e31 .navigation-player').fancybox({
    toolbar  : false,
    openEffect: 'elastic',
    openSpeed: 250,
    closeEffect: 'elastic',
    closeSpeed: 150,
    closeClick: true,
    closeBtn: true,
    iframe : {
      preload : true
    }
  });

  $('.e31 .design-content .fl').mouseenter(function(){
    $(this).find('.des').fadeIn();
  }).mouseleave(function(){
    $('.e31 .design-content .fl').find('.des').hide();
  });
  var performanceSwiper = new Swiper('.performance .custom_mobile_hidden .swiper-container', {
    watchSlidesProgress: true,
    slidesPerView: 3,
    centeredSlides: true,
    loop: true,
    //     autoplay: {
    //       delay: 4000,
    //       stopOnLastSlide: false,
    //       disableOnInteraction: true,
    //     },
    slideToClickedSlide: true,
    on:{
      init:function(swiper){
        slide=this.slides.eq(0);
      },
      transitionStart: function(){
      },
      transitionEnd: function(){
        $('.performance-bg').hide();
        $('.performance-bg'+(this.realIndex+1)).show();
      },
    }

  });
  function addEvent(obj, xEvent, fn) {
    if (obj.attachEvent) {
      obj.attachEvent('on' + xEvent, fn);
    } else {
      obj.addEventListener(xEvent, fn, false);
    }
  };
  var mousewheelNavigation = document.getElementById('navigation');
  var mousewheelPerformance = document.getElementById('performance');
  var mousewheelWay = document.getElementById('way');
  addEvent(mousewheelNavigation, 'mousewheel', onMouseWheelStop, false);
  addEvent(mousewheelNavigation, 'DOMMouseScroll', onMouseWheelStop, false);
  addEvent(mousewheelPerformance, 'mousewheel', onMouseWheelPerformance, false);
  addEvent(mousewheelPerformance, 'DOMMouseScroll', onMouseWheelPerformance, false);
  addEvent(mousewheelWay, 'mousewheel', onMouseWheelStop, false);
  addEvent(mousewheelWay, 'DOMMouseScroll', onMouseWheelStop, false);
  function onMouseWheelPerformance(e) {
    e = e || window.event;
    var divS = 0;
    if (e.wheelDelta) {
      divS = e.wheelDelta;
    } else if (e.detail) {
      divS = e.detail;
    };
    //     performanceSwiper.autoplay.start();
  };
  function onMouseWheelStop(e) {
    e = e || window.event;
    var divS = 0;
    if (e.wheelDelta) {
      divS = e.wheelDelta;
    } else if (e.detail) {
      divS = e.detail;
    };
    performanceSwiper.slideTo(3, 1000, false)
    performanceSwiper.autoplay.stop();
  };

  var wayHeight = $('.way .way-bg').height() || '860px';
  $('.way .box-shadow .pr').height(wayHeight);
  $('.way .box-shadow .pr').mouseenter(function(){
    var $this = $(this);
    var thisClass = $this.attr('id');
    $('.way .way-bg').hide();
    $('.way .way-bg-'+thisClass).show();
    $this.find('.font18').show();
    $this.find('.des-note').show();
    $this.siblings().find('.font18').hide();
  }).mouseleave(function(){
    $('.way .box-shadow .pr').find('.font18').hide();
    $('.way .box-shadow .pr').find('.des-note').hide();
  });




  var serviceSwiper = new Swiper('.service .swiper-container', {
    effect : 'fade',
    fadeEffect: {
      crossFade: true,
    },
    initialSlide:0,
    slidesPerView: 1,
    grabCursor:true,
    freeMode : true,
    freeModeMomentum : false,
    speed:1500,
    mousewheel: {
      releaseOnEdges:true,
    },
    //     autoplay: {
    //       delay: 6000,
    //       stopOnLastSlide: false,
    //       disableOnInteraction: true,
    //     },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        var paginationhtml = '<img src="https://cdn.shopify.com/s/files/1/0350/3040/1157/files/e31-service-icon'+(index+1)+'.png?v=1588755453" alt="" class="service-icon">'+
            '<img src="https://cdn.shopify.com/s/files/1/0350/3040/1157/files/e31-service-icon'+(index+1)+'-hover.png?v=1588755466" alt="" class="service-icon-hover">'
        return '<div class="' + className + '">'+paginationhtml+'</div>';
      }
    },

  });
  var featuresSwiper = new Swiper('.features .swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 14,
    loop: true,
    autoplay: {
      delay: 10000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  //   mobile
  var functionsMbSwiper = new Swiper('.functions .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        var paginationhtml = '<img src="https://cdn.shopify.com/s/files/1/0350/3040/1157/files/e31-func-icon'+(index+1)+'.png?v=1587975971" alt="" class="function-icon-hover">'+
            '<img src="https://cdn.shopify.com/s/files/1/0350/3040/1157/files/e31-functions-icon'+(index+1)+'-mb.png?v=1588665569" alt="" class="function-icon">'
        return '<div class="' + className + '">'+paginationhtml+'</div>';
      },
    },
  });
  var performanceMbSwiper = new Swiper('.performance .custom_mobile_show .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  var wayMbSwiper = new Swiper('.way .custom_mobile_show .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });
  var moppingMbSwiper = new Swiper('.mopping .custom_mobile_show .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  var designMbSwiper = new Swiper('.design .custom_mobile_show .swiper-container', {
    slidesPerView: 1,
    centeredSlides: true,
    loop: true,
    autoplay: {
      delay: 6000,
      stopOnLastSlide: false,
      disableOnInteraction: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
  });
  if($(window).width() < 768){
    $('.performance .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.performance .custom_mobile_show .overlay-img').height()+20)+'px'));
    $('.way .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.way .custom_mobile_show .overlay-img').height()+20)+'px'));
    $('.mopping .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.mopping .custom_mobile_show .overlay-img').height()+20)+'px'));
    $('.service .swiper-pagination-bullets').css('top',(($('.service .half-img img').height()-20)+'px'));
    $('.design .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.design .custom_mobile_show .overlay-img').height()+20)+'px'));
    $('.features .custom_mobile_show.swiper-pagination-bullets').css('top',(($('.features .custom_mobile_show .overlay-img').height()+20)+'px'));
  }
  window.onresize=function(){
    if($(window).width() < 768){
      $('.performance .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.performance .custom_mobile_show .overlay-img').height()+20)+'px'));
      $('.way .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.way .custom_mobile_show .overlay-img').height()+20)+'px'));
      $('.mopping .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.mopping .custom_mobile_show .overlay-img').height()+20)+'px'));
      $('.service .swiper-pagination-bullets').css('top',(($('.service .half-img img').height()-20)+'px'));
      $('.design .custom_mobile_show .swiper-pagination-bullets').css('top',(($('.design .custom_mobile_show .overlay-img').height()+20)+'px'));
      $('.features .custom_mobile_show.swiper-pagination-bullets').css('top',(($('.features .custom_mobile_show .overlay-img').height()+20)+'px'));
    }

  }

})
function toggleMbFn(){
  $('#barE31 .mobile-mega-menu').hide();
  window.location.href = "#navigation";
}

function showSpec()  {
  $('.spec-icon').removeClass('icon-plus').addClass('icon-minus');
  $(".spec-click").attr("onclick", "hideSpec()");
  $('.spec-content').show();
}
function hideSpec() {
  $('.spec-icon').removeClass('icon-minus').addClass('icon-plus');
  $(".spec-click").attr("onclick", "showSpec()");
  $('.spec-content').hide();
}

function showFaqs()  {
  $('.faqs-icon').removeClass('icon-plus').addClass('icon-minus');
  $(".faqs-click").attr("onclick", "hideFaqs()");
  $('.faqs-content').show();
}
function hideFaqs() {
  $('.faqs-icon').removeClass('icon-minus').addClass('icon-plus');
  $(".faqs-click").attr("onclick", "showFaqs()");
  $('.faqs-content').hide();
}
function openDialogFn(obj){
  //   return window.location.href= "https://www.amazon.com/dp/B088WMZSP5";
  if(obj == 'downloads'){
    $('.downloads .text').css('transform','translateX(-50%)');
    $('.'+obj+'-dialog').fadeIn();
  }else{
    ga('send', 'event', {
      eventCategory: 'Amazon US Link',
      eventAction: 'click',
      eventLabel: '标识名',
      transport: 'beacon'
    });
    //window.open('https://www.amazon.com/gp/product/B089R3K2X6?ie=UTF8&tag=kyvolsales-20&camp=1789&linkCode=xm2&creativeASIN=B089R3K2X6','_blank'); 
    window.open('https://www.amazon.com/gp/product/B089R3K2X6/ref=as_li_tl?ie=UTF8&tag=kyvolecommerc-20&camp=1789&creative=9325&linkCode=as2&creativeASIN=B089R3K2X6&linkId=51de3c6fb8dc171841d540200054bab8','_blank');
  }
}
function closedDialogFn(obj){
  if(obj == 'downloads'){
    $('.downloads .text').css('transform','translateX(0%)');
  }
  $('.'+obj+'-dialog').hide();
}

function openDialogFncart(param){
  //   if(param == 'add'){
  //     $('.pupaddtocart .shopify-payment-button').hide();
  //     $('.pupaddtocart .add_to_cart').show();
  //   }
  //   if(param == 'buy'){
  //     $('.pupaddtocart .shopify-payment-button').show();
  //     $('.pupaddtocart .add_to_cart').hide();
  //   }

  $('.kyvol-add-to-cart').click();
  //$('.pupaddtocart').fadeIn();

} 
function closedDialogFncart(){
  $('.pupaddtocart').hide();
}
